export default __webpack_public_path__ + "static/media/header-minerva-consumer.5335b48d.jpg";